import type Tracker from '@openreplay/tracker'

let tracker: Tracker | null = null

const OPENREPLAY_PROJECT_KEY =
  import.meta.env.VITE_OPENREPLAY_PROJECT_KEY || 'NpFoQqOeQE9PePLSegte'
const OPENREPLAY_INGEST_POINT =
  import.meta.env.VITE_OPENREPLAY_INGEST_POINT ||
  'https://openreplay.aminsaedi.com/ingest'

export function initSessionReplay() {
  // Only run in browser
  if (typeof window === 'undefined') return

  // Skip if not configured
  if (!OPENREPLAY_PROJECT_KEY) {
    console.log(
      '[Session Replay] VITE_OPENREPLAY_PROJECT_KEY not set, session replay disabled',
    )
    return
  }

  import('@openreplay/tracker')
    .then(({ default: TrackerClass }) => {
      tracker = new TrackerClass({
        projectKey: OPENREPLAY_PROJECT_KEY,
        ingestPoint: OPENREPLAY_INGEST_POINT || undefined,
        __DISABLE_SECURE_MODE: location.protocol !== 'https:',
        // PlainFetched (3): fetches CSS files and embeds as <style> nodes in the recording.
        // This preserves all CSS features (oklch colors, @layer, custom properties)
        // that mode 1 (AdoptedStyleSheet) can miss with Tailwind CSS v4.
        inlineCss: 3,
        resourceBaseHref: window.location.origin,
        css: {
          scanInMemoryCSS: true,
        },
        canvas: {
          disableCanvas: false,
          useAnimationFrame: true,
          fileExt: 'webp',
        },
        network: {
          failuresOnly: false,
          sessionTokenHeader: false,
          ignoreHeaders: ['Authorization', 'Cookie'],
          capturePayload: true,
          captureInIframes: true,
          sanitizer: (data) => {
            // Redact sensitive fields from network payloads
            if (data.request.body) {
              try {
                const body = JSON.parse(data.request.body)
                if (body.password) body.password = '[REDACTED]'
                if (body.token) body.token = '[REDACTED]'
                data.request.body = JSON.stringify(body)
              } catch {
                // Not JSON, leave as-is
              }
            }
            return data
          },
        },
        obscureTextEmails: true,
        obscureInputEmails: true,
      })

      tracker
        .start()
        .then(() => {
          console.log('[Session Replay] OpenReplay started')
        })
        .catch((err) => {
          console.warn('[Session Replay] OpenReplay failed to start:', err)
        })
    })
    .catch((err) => {
      console.warn('[Session Replay] Failed to load OpenReplay:', err)
    })
}

export function getTracker(): Tracker | null {
  return tracker
}

export function setSessionUser(
  userId: string,
  metadata?: Record<string, string>,
) {
  if (tracker) {
    tracker.setUserID(userId)
    if (metadata) {
      Object.entries(metadata).forEach(([key, value]) => {
        tracker?.setMetadata(key, value)
      })
    }
  }
}
